// Opaque two-tone edges remain legible on both roofs and pale road-map ground.
// The 3.4 px casing leaves 0.8 px of dark contrast beside the 1.8 px colour edge.
export const BUILDING_COLORS = {
  context: '#67e8f9',
  served: '#6ee7b7',
  selected: '#fde68a',
  halo: '#0f172a',
};

export const BUILDING_HALO_STYLE = {
  fillOpacity: 0,
  strokeColor: BUILDING_COLORS.halo,
  strokeOpacity: 1,
  strokeWeight: 3.4,
  clickable: false,
  zIndex: 0,
};

export function designBuildingStyle({ served = false, selected = false, outlineOnly = false } = {}) {
  return {
    fillColor: selected ? '#92400e' : served ? '#065f46' : '#334155',
    fillOpacity: outlineOnly ? 0 : 0.12,
    strokeColor: selected ? BUILDING_COLORS.selected : served ? BUILDING_COLORS.served : BUILDING_COLORS.context,
    strokeOpacity: 1,
    strokeWeight: selected ? 2.2 : 1.8,
    zIndex: 1,
  };
}

// Use the actual household assignments, not cabinet coverage or proximity.
// MFATs have a separate direct assignment; legacy leaf types still load in old projects.
export function servedBuildingIds(result) {
  const ids = new Set();
  for (const e of result?.elements || []) {
    const attrs = e.attrs || {};
    const buildings = e.type === 'mfat_l2' ? attrs.direct_building_ids
      : ['fat', 'mfat', 'sfat'].includes(e.type) ? attrs.building_ids : [];
    for (const id of buildings || []) ids.add(String(id));
  }
  return ids;
}
